import { t } from "@/i18n-js/instance";
import { useEmailHubModal } from "@/react/components/shared/EmailHub/LandingPage/Modal";
import { Icon } from "@circle-react-shared/Icon";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";
import { BillingDetailsContainer } from "./BillingDetailsContainer";

const localeRoot = "settings.billing.manage_billing.email_hub_banner";

export const EmailHubBanner = () => {
  const emailHubModal = useEmailHubModal();

  return (
    <BillingDetailsContainer>
      <div className="flex flex-row items-start gap-x-4">
        <div className="shrink-0 self-start">
          <Icon
            type="20-send"
            size={20}
            useWithFillCurrentColor
            useWithStrokeCurrentColor
            className="shrink-0 self-start"
          />
        </div>
        <div className="flex flex-col gap-y-2">
          <Typography.LabelMd weight="semibold">
            {t(`${localeRoot}.title`)}
          </Typography.LabelMd>

          <Typography.BodySm color="text-default">
            {t(`${localeRoot}.description`)}
          </Typography.BodySm>

          <Button
            variant="secondary"
            className="mt-2 w-fit"
            onClick={() => emailHubModal.show()}
          >
            {t(`${localeRoot}.enable_now`)}
          </Button>
        </div>
      </div>
    </BillingDetailsContainer>
  );
};
